// import React from "react";
// import { BrowserRouter as Router, Routes, Route ,useLocation } from "react-router-dom";
// import Nav from './Component/Nav';
// import Footer from './Component/Footer';
// import Home from './Component/Home';
// import WhoweAre from "./Component/WhoweAre";
// import Contactus from "./Component/Contactus";
// import WhatWeDo from "./Component/WhatWeDo";
// import Gaming from "./Component/Gaming";
// import Jobportal from './Component//Jobportal';
// import Program from './Component/Program';


// import PCMobileApplications from "./Component/PCMobileApplications";
// import Itservices from "./Component/Itservices";





// import HumanResource from "./Component/HumanResource";



// import Outdoor from"./Component/Outdoor";
// import ScrollTriangle  from "./Component/ScrollTriangle ";
// import RegistrationForm  from "./Component/RegistrationForm";
// import Cart from "./Component/Cart";
// import WhatsAppChat from './Component/WhatsAppChat'; // Import WhatsAppChat component
// import ShoppingCart from'./Component/ShoppingCart';
// import LoginEmp from "./Component/LoginDashboard";
// import SignUpEmp from "./Component/SignupDashboard";
// import ForgotEmp from "./Component/ForgotPassword";
// import Enroll from"./Component/Enroll";
// import SpeakerPage from'./Component/SpeakerPage';
// import Fixture from'./Component/Fixture';
// import DigitalC from'./Component/DigitalC';
// import Puthonpage from'./Component/Puthonpage';

// import Reactpage from'./Component/Reactpage';
// import Sopftskillpage from'./Component/Sopftskillpage';
// import Digitalpresenceskillpage from'./Component/Digitalpresenceskillpage';
// import Filterpage from'./Component/Filterpage';
// import Virtualpage from'./Component/Virtualpage';
// import FilterToll from'./Component/FilterToll';
// import Filterdigital from'./Component/Filterdigital';
// import Filterjava from'./Component/Filterjava';
// import FilterPython from'./Component/FilterPython';
// import Filterrext from'./Component/Filterrext';




// // import Gaming from"./Component/Gaming";


// function App() {
//   const location = useLocation();

//   // Conditionally render Footer based on the path
//   const showFooter = location.pathname !== '/filterpage';
//   return (

//     <div>
//     <Router>
//       <ScrollTriangle />
//       <Nav />
//       <Routes>


//         <Route path="/" element={<Home />} />
//         {/* <Route path="/about-us" element={<AboutUs />}></Route> */}
//         <Route path="/who-we-are" element={<WhoweAre />}></Route>
//         <Route path="/contact" element={<Contactus />}></Route>
//         <Route path="/what-we-do" element={<WhatWeDo />}></Route>
//         <Route path="/Jobportal" element={<Jobportal />}></Route>
//         <Route path="/Program" element={<Program />}></Route>
//         <Route path="/SpeakerPage" element={< SpeakerPage />}></Route>
//         <Route path="/Reactpage" element={< Reactpage />}></Route>
//         <Route path="/Sopftskillpage" element={<  Sopftskillpage />}></Route>
//         <Route path="/Digitalpresenceskillpage" element={<  Digitalpresenceskillpage />}></Route>












//         <Route path="/gamingpage" element={<Gaming />}></Route>
//          <Route path="/Virtualpage" element={<Virtualpage/>}></Route>


//         <Route path="/Outdoor" element={<Outdoor/>}></Route>
//         <Route path="/logindashboard" element={<LoginEmp/>}></Route>

//         <Route path="/web-mobile-applications" element={<PCMobileApplications />}></Route>
//         <Route path="/it-services" element={<Itservices />}></Route>
//         <Route path="/Fixture" element={<Fixture />}></Route>
//         <Route path="/DigitalC" element={<DigitalC />}></Route>
//         <Route path="/Puthonpage" element={<Puthonpage/>}></Route>
//         <Route path="/filterpage" element={<Filterpage/>}></Route>
//          <Route path="/FilterToll" element={<FilterToll/>}></Route>
//           <Route path="/Filterdigital" element={<Filterdigital/>}></Route>
//           <Route path="/Filterjava" element={<Filterjava/>}></Route>
//           <Route path="/FilterPython" element={<FilterPython/>}></Route>

//           <Route path="/Filterrext" element={<Filterrext/>}></Route>



//         <Route path="/human-resource" element={<HumanResource/>}></Route>
//         <Route path="/registration-form" element={<RegistrationForm/>}></Route>
//         <Route path="/cart-page" element={<Cart/>}></Route>
//         <Route path="/shoppingcart" element={<ShoppingCart/>}></Route>
//         <Route path="/signupdashboard" element={<SignUpEmp/>}></Route>
//         <Route path="/forgot" element={<ForgotEmp/>}></Route>
//         <Route path="/Enroll" element={<Enroll/>}></Route>







//       </Routes>

//     {showFooter && <Footer />}
//       <WhatsAppChat /> {/* Add the WhatsApp chat component here */}
//     </Router>
//   </div>
//   );
// }

// export default App;
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Nav from './Component/Nav';
import Footer from './Component/Footer';
import Home from './Component/Home';
import WhoweAre from "./Component/WhoweAre";
import Contactus from "./Component/Contactus";
import WhatWeDo from "./Component/WhatWeDo";
import Gaming from "./Component/Gaming";
import Jobportal from './Component/Jobportal';
import Program from './Component/Program';
import PCMobileApplications from "./Component/PCMobileApplications";
import Itservices from "./Component/Itservices";
import HumanResource from "./Component/HumanResource";
import Outdoor from "./Component/Outdoor";
import ScrollTriangle from "./Component/ScrollTriangle ";
import RegistrationForm from "./Component/RegistrationForm";
import Cart from "./Component/Cart";
import WhatsAppChat from './Component/WhatsAppChat';
import ShoppingCart from './Component/ShoppingCart';
import LoginEmp from "./Component/LoginDashboard";
import SignUpEmp from "./Component/SignupDashboard";
import ForgotEmp from "./Component/ForgotPassword";
import Enroll from "./Component/Enroll";
import SpeakerPage from './Component/SpeakerPage';
import Fixture from './Component/Fixture';
import DigitalC from './Component/DigitalC';
import Puthonpage from './Component/Puthonpage';
import Reactpage from './Component/Reactpage';
import Sopftskillpage from './Component/Sopftskillpage';
import Digitalpresenceskillpage from './Component/Digitalpresenceskillpage';
import Filterpage from './Component/Filterpage';
import Virtualpage from './Component/Virtualpage';
import FilterToll from './Component/FilterToll';
import Filterdigital from './Component/Filterdigital';
import Filterjava from './Component/Filterjava';
import FilterPython from './Component/FilterPython';
import Filterrext from './Component/Filterrext';
import Filtercarrerskill from './Component/Filtercarrerskill';
import Filtersoftskill from './Component/Filtersoftskill';
import Filterdigitalpresence from './Component/Filterdigitalpresence';
import Newallcardspage from './Component/Newallcardspage';
import Navtwo from './Component/Navtwo';
import Secondactiveprograms from './Component/Secondactiveprograms';
import Thirdactiveprogram from './Component/Thirdactiveprogram'
import Carierprogramepage from './Component/Carierprogramepage';
import Gstprogrampage from './Component/Gstprogrampage';


import Tollfixturecontact from "./Component/Tollfixturecontact";
import Digitalfactarycontact from "./Component/Digitalfactarycontact";
import Javacontact from "./Component/Javacontact";
import Pythoancontact from "./Component/Pythoancontact";
import Fluttercontact from "./Component/Fluttercontact";
import Careercontact from "./Component/Careercontact";
import Foumdationcontact from "./Component/Foumdationcontact";
import Digitalprasencecontact from "./Component/Digitalprasencecontact";
import Springbootpage from "./Component/Springbootpage";
import Htmlpage from "./Component/Htmlpage";
import InternshipDetails from "./Component/InternshipDetails";
import ScrollToTop from "./Component/Scrolltop";
import FacultySection from "./Component/FacultiesSection.jsx";
import FacultyDetails from "./Component/FacultyDetails.jsx";

import WebinarDetails from './Component/WebinarDetails';

function App() {
  return (
    <Router>
      <AppWithRouter />
    </Router>
  );
}

function AppWithRouter() {
  const location = useLocation();

  // Conditionally render Footer based on the path
  // const showFooter = location.pathname !== '/filterpage';
  // const showFooter1 = location.pathname !== '/Filterjava';
  //  const showFooter2 = location.pathname !== '/Filterrext';
  //   const showFooter3 = location.pathname !== '/FilterPython';
  //     const showFooter4 = location.pathname !== '/Filterdigital';
  //       const showFooter5 = location.pathname !== '/FilterToll';
  const showFooter6 = location.pathname !== '/cart-page';
  // const showFooter7 = location.pathname !== '/Newallcardspage';
  // const showFooter8 = location.pathname !== '/Secondactiveprograms';



  const showNavtwo =
    //  location.pathname === '/filterpage' ||
    // location.pathname === '/Filterjava' ||
    // location.pathname === '/Filterrext' ||
    // location.pathname === '/FilterPython' ||
    // location.pathname === '/Filterdigital' ||
    // location.pathname === '/FilterToll' ||
    location.pathname === '/cart-page' ||
    // location.pathname === '/Virtualpage' ||
    location.pathname === '/Newallcardspage' ||

    // location.pathname === '/DigitalC'||
    //  location.pathname === '/fixture'||

    // location.pathname === '/it-services'||
    // location.pathname === '/Puthonpage'||
    // location.pathname === '/Reactpage'||

    // location.pathname === '/Outdoor'||
    // location.pathname === '/Sopftskillpage'||

    //  location.pathname === '/Digitalpresenceskillpage'||
    //  location.pathname === '/Filtercarrerskill'||
    // location.pathname === '/Filtersoftskill'||
    location.pathname === '/contact' ||
     location.pathname === '/Secondactiveprograms' ||
    location.pathname === '/Thirdactiveprogram' ||
    location.pathname === '/tollfixture-contact' ||
    location.pathname === '/Digitalfactarycontact' ||
    location.pathname === '/Javacontact'||
    location.pathname === '/Pythoancontact'||
    location.pathname === '/Fluttercontact'||
    location.pathname === '/Careercontact'||
    location.pathname === '/softskillcontact'||
    location.pathname === '/Digitalprasencecontact';
  
    
 
  








  return (
    <div>
      {showNavtwo && <Navtwo />}
      {/* <ScrollTriangle /> */}
      {showFooter6 && <Nav />}
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/who-we-are" element={<WhoweAre />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/Jobportal" element={<Jobportal />} />
        <Route path="/Program" element={<Program />} />
        <Route path="/SpeakerPage" element={<SpeakerPage />} />
        <Route path="/Reactpage" element={<Reactpage />} />
        <Route path="/Sopftskillpage" element={<Sopftskillpage />} />
        <Route path="/Digitalpresenceskillpage" element={<Digitalpresenceskillpage />} />
        <Route path="/gamingpage" element={<Gaming />} />
        <Route path="/Virtualpage" element={<Virtualpage />} />
        <Route path="/Outdoor" element={<Outdoor />} />
        <Route path="/logindashboard" element={<LoginEmp />} />
        <Route path="/web-mobile-applications" element={<PCMobileApplications />} />
        <Route path="/it-services" element={<Itservices />} />
        <Route path="/Fixture" element={<Fixture />} />
        <Route path="/DigitalC" element={<DigitalC />} />
        <Route path="/Puthonpage" element={<Puthonpage />} />
        <Route path="/filterpage" element={<Filterpage />} />
        <Route path="/FilterToll" element={<FilterToll />} />
        <Route path="/Filterdigital" element={<Filterdigital />} />
        <Route path="/Filterjava" element={<Filterjava />} />
        <Route path="/FilterPython" element={<FilterPython />} />
        <Route path="/Filterrext" element={<Filterrext />} />
        <Route path="/Filtercarrerskill" element={<Filtercarrerskill />} />
        <Route path="/Filtersoftskill" element={<Filtersoftskill />} />
        <Route path="/Filterdigitalpresence" element={<Filterdigitalpresence />} />
        <Route path="/Newallcardspage" element={<Newallcardspage />} />
         <Route path="/webinar/:id" element={<WebinarDetails />} />

        <Route path="/Secondactiveprograms" element={<Secondactiveprograms />} />
        <Route path="/Thirdactiveprogram" element={<Thirdactiveprogram />} />
        <Route path="/Carierprogramepage" element={<Carierprogramepage />} />
        <Route path="/Gstprogrampage" element={<Gstprogrampage />} />
        <Route path="/tollfixture-contact" element={<Tollfixturecontact />} />
        <Route path="/Digitalfactarycontact" element={<Digitalfactarycontact />} />
        <Route path="/Javacontact" element={<Javacontact />} />
        <Route path="/Pythoancontact" element={<Pythoancontact />} />
        <Route path="/Fluttercontact" element={<Fluttercontact />} />
        <Route path="/Careercontact" element={<Careercontact />} />
        <Route path="/softskillcontact" element={<Foumdationcontact />} />
        <Route path="/Digitalprasencecontact" element={<Digitalprasencecontact />} />
        <Route path="/Springbootpage" element={<Springbootpage />} />
        <Route path="/Htmlpage" element={<Htmlpage />} />
        <Route path="/InternshipDetails/:id" element={<InternshipDetails />} />
         <Route path="/faculty" element={<FacultySection />} />
          <Route path="/faculty/:id" element={<FacultyDetails />} />




        <Route path="/human-resource" element={<HumanResource />} />
        <Route path="/registration-form" element={<RegistrationForm />} />
        <Route path="/cart-page" element={<Cart />} />
        <Route path="/shoppingcart" element={<ShoppingCart />} />
        <Route path="/signupdashboard" element={<SignUpEmp />} />
        <Route path="/forgot" element={<ForgotEmp />} />
        <Route path="/Enroll" element={<Enroll />} />
      </Routes>
    

      {showFooter6 && <Footer />}
      {/* <WhatsAppChat /> */}
    </div>
  );
}

export default App;
